import { Article } from "./articles";

const myArticlesEn: Article[] = [
	{
		date: "2023 7/7",
		title: "Build Time Improvement in CL iOS Team",
		description: "I'm Shimomura (@s2mr), an iOS engineer at the video streaming app \"CL\". CL is a service where you can watch live cast videos and music videos of LDH-affiliated groups and artists. It's been three years since its release in June 2020, and four years including the development period. Since the app includes streaming features, it has grown to a large scale. In this article, I'd like to summarize what we've tried in CL to improve build times.",
		keywords: [],
		style: ``,
		link: "https://developers.cyberagent.co.jp/blog/archives/42548/",
		body: null,
	},
	{
		date: "2022 6/13",
		title: "Junior Engineer Explains! Unique Initiatives for Building High-Quality Products in \"CL\"",
		description: "The CL Business Division at CyberAgent, Inc. develops \"CL,\" a FanTech service that delivers LDH's entertainment content. We share the know-how cultivated in this process in a series format. The 4th installment introduces unique initiatives that \"CL\" is working on to create high-quality products.",
		keywords: [],
		style: ``,
		link: "https://creatorzine.jp/article/detail/3088",
		body: null,
	},
	{
		date: "2019 9/24",
		title: "Displaying Transparent Videos in AR Space Using Chroma Key Compositing (iOSDC Japan 2019 Session Report)",
		description: "At iOSDC Japan 2019 held from September 5 (Thu) to September 7 (Sat), CyberAgent served as a diamond sponsor again this year, and five engineers gave presentations. Today, on behalf of speaker Hattori (@shmdevelop), Shimomura (@_kzumu) looks back on the session \"Displaying Transparent Videos in AR Space Using Chroma Key Compositing.\"",
		keywords: [],
		style: ``,
		link: "https://developers.cyberagent.co.jp/blog/archives/23246/",
		body: null,
	}
];

export default myArticlesEn;
